import axios from "axios";

export function getAttributionId() {
    const myUrl = new URL(window.location.href)
    if (myUrl.searchParams.has('attributionId')) {
        return myUrl.searchParams.get('attributionId');
    } else if (myUrl.searchParams.has('attributionid')) {
        return myUrl.searchParams.get('attributionid');
    }
    const att1 = localStorage.getItem('attributionId');
    if (att1) {
        return att1;
    }
    const att2 = localStorage.getItem('attributionid');
    if (att2) {
        return att2;
    }
    const att3 = sessionStorage.getItem('attributionId');
    if (att3) {
        return att3;
    }
    const att4 = sessionStorage.getItem('attributionid');
    if (att4) {
        return att4;
    }
    else {
        return "0"
    }
}
export function setAttributionId(id) {
    sessionStorage.setItem('attributionId', id.toString())
}
export function bowserInfo() {
    const u = navigator.userAgent;
    return {
        mobile: u.match(/Mobile/),
        android: u.match(/Android/),
        iPhone: u.match(/iPhone/),
        iPad: u.match(/iPad/),
        ios: u.match(/iPhone/) || u.match(/iPad/)
    }
}

export function downloadApk() {
    // dmmPreRegister();
    dmmLogin();
    return;
    const params = {};
    params.gameId = process.env.REACT_APP_GAME_ID;
    params.attributionId = getAttributionId();
    const bInfo = bowserInfo();
    if (bInfo.ios) {
        window.location.href = 'http://hkhydfh-ios.18-jgg.com';
    } else {
        axios.get(process.env.REACT_APP_LAMBDA_URL + '/getApkUrl', { params }).then(resp => {
            let downloadUrl = new URL(resp.data);
            window.location.href = downloadUrl.toString() + "?r=download";
        })
    }
}
export function RedircePage() {
    return;
    const bInfo = bowserInfo();
    if (!bInfo.mobile) {
        const attributionId = getAttributionId();
        let myUrl;
        if (window.location.host.indexOf('jgg18.') > -1) {
            myUrl = new URL("https://" + window.location.host.replace("m", "www"))
        } else {
            myUrl = new URL(process.env.PC_DOMAIN || 'https://www.jgg18.net')
        }
        if (attributionId !== '0') {
            myUrl.searchParams.set('attributionId', attributionId);
        }
        window.location.href = myUrl.toString();
    }
}
export function RedircePageByPc() {
    return;
    const bInfo = bowserInfo();
    if (!bInfo.mobile) {
        const attributionId = getAttributionId();
        let myUrl;
        if (window.location.host.indexOf('jgg18.') > -1) {
            myUrl = new URL("https://" + window.location.host.replace("m", "www"))
        } else {
            myUrl = new URL(process.env.PC_DOMAIN || 'https://www.jgg18.net')
        }
        if (attributionId !== '0') {
            myUrl.searchParams.set('attributionId', attributionId);
        }
        window.location.href = myUrl.toString();
    }
}
export function RedircePage2MLP() {
    const bInfo = bowserInfo();
    if (bInfo.mobile) {
        const attributionId = getAttributionId();
        let myUrl = new URL(process.env.REACT_APP_M_LP );
        if (attributionId !== '0') {
            myUrl.searchParams.set('attributionId', attributionId);
        }
        window.location.href = myUrl.toString();
    }
}
export function goHome() {
    window.location.href = process.env.REACT_APP_JGG_HOME
}
export function DownloadSimulator() {
    window.location.href = 'https://tw.bignox.com/tw/download/fullPackage?beta'
}
export function GetIPAUrl(slug) {
    axios.get(process.env.REACT_APP_LAMBDA_URL + '/getIpaUrl?slug=' + slug, {}).then(resp => {
        let downloadUrl = new URL(resp.data);
        window.location.href = downloadUrl.toString() + "?r=download";
    })
}
export function initAttributionId() {
    let att = getAttributionId();
    console.log('attr=', att)
    if (att !== '2') {
        setAttributionId(att);
    }
}
export function addDMMScripts() {
    //  var firstPage=document.getElementById("firstPage");
    //  var elClone=firstPage.cloneNode(true);
    //  firstPage.parentNode.removeChild(firstPage);
    //  var outEl=document.getElementById("out");
    //  outEl.appendChild(elClone);
    let script2 = document.createElement("script")
    script2.src = "https://games.dmm.co.jp/detail/js/skip_detail_with_dealer_policy.js";
    document.getElementsByTagName("body")[0].appendChild(script2);
}
export function dmmLogin() {
    // dmmPreRegister();
    analytics_pageview(window.location.pathname+':click'+getAttributionId())
    // window.location.href = 'https://games.dmm.com/detail/gyakuoudensetu'
    window.location.href='https://games.dmm.co.jp/en/detail/gyakuoudensetu/' 
}
//dmm事前登录
export function dmmPreRegister() {
    var tokenApi = 'https://games.dmm.com/detail/api/v1/emulator-pre-registration/ajax-create-token/'
    var preRegistUrl = 'http://games.dmm.com/detail/api/v1/emulator-pre-registration/?'
    var params = ''
    var successUrl = 'https://www.kingofkinksjp.com/games/kok/index.html'
    var alreadyUrl = 'https://www.kingofkinksjp.com/games/kok/index.html'
    var errorUrl =  'https://www.kingofkinksjp.com/games/kok/index.html'
    var notification= 'https://www.kingofkinksjp.com/games/kok/index.html'
    var titleId = 'gyakuoudensetu'
    var myapp="1"
    var jsonData={
        title_id: titleId,
    }
    
    // fetch(tokenApi + "?title_id=" + titleId,{credentials: 'include',mode: 'cors'}).then(resp => {
    //     let csrfToken = resp.csrf_token;
    //     params = "csrf_token=" + csrfToken + "&title_id=" + titleId + "&success_url=" + successUrl + "&already_url=" + alreadyUrl + "&error_url=" + errorUrl + "&notification=" + notification + "&myapp=" + myapp;
    //     window.location.href = preRegistUrl + params;
    // }).catch(reason=>{
    //     console.log(reason)
    // })
    axios({
        type: 'GET',
        url: tokenApi+"?title_id="+titleId,
        // dataType: 'json',
        // data: jsonData,
        crossDomain: true,
        withCredentials: true,
        xhrFields: {
            withCredentials: true
        },
    })
    .then( (responceJson)=> {
        console.log(responceJson);
        //Execute Pre-Registration API
        // $('.csrf_token').val(responceJson.csrf_token);
        let csrfToken = responceJson.csrf_token;
        params = "csrf_token=" + csrfToken + "&title_id=" + titleId + "&success_url=" + encodeURIComponent(successUrl) + "&already_url=" + encodeURIComponent(alreadyUrl) + "&error_url=" + encodeURIComponent(errorUrl) + "&notification=" + notification + "&myapp=" + myapp;
        window.location.href = preRegistUrl + params;
    })
    .catch(  (responceJson)=> {
        console.log(responceJson);
        alert('catch alert')
        // window.location.href = errorUrl;
    });
}


export function analytics_pageview(path,eventId){
    
    path=path ||window.location.pathname;
    path=(process.env.REACT_APP_ANALYTICS_SITE||"8")+"#"+path;
   
    const formData=new FormData();
    if(eventId){
        formData.append('EventId',eventId)
    }
    formData.append('Path',path);
    navigator.sendBeacon(process.env.REACT_APP_ANALYTICS_URL,formData);
    console.log("统计：",path,process.env.REACT_APP_ANALYTICS_URL)
  }
  